module.exports = __webpack_public_path__ + "static/img/ava2.9aadba59.png";